import memoize from "fast-memoize";

import { cBigNumber } from "../../classes/BigNumber";
import { cChromiaOption } from "../../classes/chrOption";
import { cChromiaOrder } from "../../classes/chrOrder";
import { iChrBalance, iWithdrawRequest } from "../../interfaces/chrInterfaces";
import { itemIds } from "../../settings";
import { store } from "../../store/store";
import { getGtxClient } from "./getGtxClient";
import { cChrItem } from "../../classes/cChrItem";
import { cAllInfo } from "../../classes/AllInfo";


export const getAllAssetsQuery = memoize(async () => {
	const response = await (await getGtxClient()).query("ft4.get_all_assets", { page_size: 100, page_cursor: null });

	const res = response.data.map(asset => { return {
		...asset,
		id: asset.id.toString('hex'),

	}});
	console.log('ft4.get_all_assets: ', res);

	return res;
});

// export const getAssetBallancesQuery = async (assetId: string) => {
export const getAssetBallancesQuery = async (): Promise<iChrBalance[]> => {
	const { chrClientAddr } = store.getState().chromia;
	if (!chrClientAddr) throw new Error();

	// const response = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: chrClientAddr, asset_id: assetId });
	const response = await (await getGtxClient()).query("ft4.get_asset_balances", { account_id: chrClientAddr,  page_size: 100, page_cursor: null});	// fix

	const res = response.data.map(balance => { return {
		balance: new cBigNumber(balance.amount.toString(), {decimals: balance.asset.decimals, currentDecimals: balance.asset.decimals}),
		asset: {
			address: balance.asset.id.toString('hex'),
			decimals: balance.asset.decimals,
			currency: balance.asset.name,
			// showDecimals: number,
			iconUrl: balance.asset.icon_url,
			symbol: balance.asset.symbol,
		}
	}});

	// console.log('ft4.get_asset_balances: ', res);

	return res;
}

export const getAssetBallanceQuery = async (assetId: string) => {
	const { chrClientAddr } = store.getState().chromia;
	if (!chrClientAddr) throw new Error();

	// const response = await (await getGtxClient()).query("ft4.get_asset_balance", { account_id: chrClientAddr, asset_id: assetId });
	const response = await (await getGtxClient()).query("get_tok_balance", { account_id: chrClientAddr, asset_id: assetId });
	// console.log('assetId: ', assetId, '\nres: ', response);
	if (!response) throw new Error();

	const res = {
		amount: new cBigNumber(response.amount.toString(), {decimals: response.asset.decimals, currentDecimals: response.asset.decimals}),
		asset: {
			...response.asset,
			id: response.asset.id.toString('hex')
		}
	};

	// console.log('ft4.get_asset_balance: ', res);

	return res;
};

export const getAllLastPeriodsQuery = async () => {
	// const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	// const res = await (await getGtxClient()).query("pickaxe_v2.GetAllPeriods", {item_id: itemIds[currentFToken][currentUToken][discountPercent]});
	const res = await (await getGtxClient()).query("pickaxe_v2.GetAllLastPeriods", {});

	// console.log('pickaxe_v2.GetAllLastPeriods: ', res);
	return res;
}

export const getAllPeriodsByItem = async (itemId?: string) => {
	const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe_v2.GetAllPeriodsByItem", {item_id: itemId || itemIds[currentFToken][currentUToken][discountPercent]});

	// console.log('pickaxe_v2.GetAllPeriodsByItem: ', res);
	return res;
}

/* export const getAllLaunchesQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetAllLaunchs", {item_id: itemIds[discountPercent]});

	// console.log('pickaxe.GetAllLaunchs: ', res);
	return res;
} */

/* export const getAllDeposQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetAllDepos", {item_id: itemIds[discountPercent]});

	// console.log('pickaxe.GetAllDepos: ', res);
	return res;
} */

export const getClientDeposQuery = async (address: string) => {
	const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe_v2.GetClientDepos", {item_id: itemIds[currentFToken][currentUToken][discountPercent], from: address});

	// console.log('pickaxe_v2.GetClientDepos: ', res);
	return res;
}

export const getClientDepoReqsQuery = async (address: string, itemId?: string) => {
	const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe_v2.GetClientDepoReqs", {item_id: itemId || itemIds[currentFToken][currentUToken][discountPercent], from: address});

	// console.log('pickaxe_v2.GetClientDepoReqs: ', res);
	return res;
}

/* export const getLaunchByPeriodIdQuery = async (periodId: number) => {
	const res = await (await getGtxClient()).query("pickaxe.GetLaunchByPeriodId", {per_id: periodId});

	console.log('pickaxe.GetLaunchByPeriodId: ', res);
	return res;
} */

export const getItems = async (): Promise<cChrItem[]> => {
	// const response = await (await getGtxClient()).query("pickaxe_v2.GetItems", {});
	const response = await (await getGtxClient()).query("pickaxe_v3.GetItems", {});
	const res = response.map(item => new cChrItem(item));
	console.log('pickaxe_v2.getItems: ', res);
	return res;
}

/* export const getItem = async (percent?: tDiscountPercent) => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe.GetItem", {item_id: itemIds[percent || discountPercent]});
	// const acc = res.acc.toString('hex');
	// console.log('pickaxe.getParams: ', res, '\nacc: ', acc, acc.length, !!acc);
	// console.log('pickaxe.getItem: ', res);
	return res;
}
 */
export const getTimeQuery = async () => {
	const res = await (await getGtxClient()).query('pickaxe_v2.GetTime', {});

	// console.log('pickaxe.GetTime: ', res);
	// return Math.floor(res/1000);
	return res;
}

/* export const getInWorkQuery = async () => {
	const { discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query('pickaxe.GetInWork', {item_id: itemIds[discountPercent]});
	
	// console.log('pickaxe.GetInWork: ', res);
	return res;
} */

export const getStateQuery = async (itemId?: string) => {
	const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query('pickaxe_v2.GetState', {item_id: itemId || itemIds[currentFToken][currentUToken][discountPercent]});

	// console.log('pickaxe_v2.GetState: ', res);
	return res;
}

export const getClientWithdrawRequestsQuery = async (address: string, itemId?: string) => {
	const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query('pickaxe_v2.GetClientWdReqs', {item_id: itemId || itemIds[currentFToken][currentUToken][discountPercent], from: address});

	const result: iWithdrawRequest[] = res.map(req => {return {
		ftWithdrawPercent: new cBigNumber(req.ft_perc).mul(100, {raiseValue: true}),
		period: req.per_num,
		utWithdrawPercent: new cBigNumber(req.ut_perc).mul(100, {raiseValue: true})
	}});

	// console.log('pickaxe_v2.GetClientWdReqs: ', result);
	return result;
}

export const getDexTime = async () => {
	const res = await (await getGtxClient()).query('slurpyswap.GetTime', {});
	
	// console.log('slurpyswap.GetTime: ', res);
	// return Math.floor(res/1000);
	return res;
}
export const getEoptTime = async () => {
	const res = await (await getGtxClient()).query('hedget.GetTime', {});
	
	// console.log('hedget.GetTime: ', res);
	// return Math.floor(res/1000);
	return res;
}

export const getItemCreator = async () => {
	const response = await (await getGtxClient()).query('GetItemCreator', {});
	const res = {
		buffer: response,
		string: response.toString('hex')
	}

	// console.log('GetItemCreator: ', res);
	return res;
}

export const getHedgetOptionById = async (id: string) => {
	const response = await (await getGtxClient()).query('hedget.GetOptById', {opt_id: id});
	return response? new cChromiaOption(response, store.getState().app.discountPercent) : null;
}

export const getHedgetOrderById = async (id: number) => {
	const response = await (await getGtxClient()).query('hedget.GetOrd', {ord_id: id});
	return response? new cChromiaOrder(response) : null;
}

export const GetClientAllQuery = async (address: string) => {
	const response = await (await getGtxClient()).query('pickaxe_v2.GetClientAll', {from: address});
	// console.log('pickaxe_v2.GetClientAll: ', response);
	return response;
}

/* export const getAllPeriodsQuery = async () => {
	const { currentFToken, currentUToken, discountPercent } = store.getState().app;
	const res = await (await getGtxClient()).query("pickaxe_v2.GetAllPeriods", {item_id: itemIds[currentFToken][currentUToken][discountPercent]});

	// console.log('pickaxe_v2.GetAllPeriods: ', res);
	return res;
} */


/// NEW ///

export const GetDeposByFrom = async (address: string) => {
	// const response = await (await getGtxClient()).query("pickaxe_v2.GetDeposByFrom", {from: address});
	const response = await (await getGtxClient()).query("pickaxe_v3.GetDeposByFrom", {from: address});
	// console.log('pickaxe_v2.GetDeposByFrom: ', response);
	const res = response.map(depo => new cAllInfo(depo));

	console.log('pickaxe_v2.GetDeposByFrom: ', res);

	return res;
}
